<template>
  <div>
    <!-- Title -->
    <h1 class="app-content-title">
      <app-i18n code="entities.subproperty.customize.title"></app-i18n>
    </h1>

    <!-- Content -->
    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>
      <!-- Form -->
      <el-form
        v-loading="updateLoading"
        class="subproperty-customize-form"
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="updateSlug"
        ref="form"
        v-if="model"
      >
        <!-- Subtitle Form -->
        <h2 class="app-content-subtitle">
          <app-i18n code="entities.subproperty.customize.subtitles.information" />
        </h2>

        <el-row :gutter="20" class="subproperty-customize-form__row">
          <!-- Slug -->
          <el-col :lg="11" :md="11" :sm="24" class="subproperty-customize-form__row__col">
            <el-form-item
              class="subproperty-customize-form__row__col__slug"
              :label="fields.slug.label"
              :prop="fields.slug.name"
              :required="fields.slug.required"
            >
              <el-input
                prefix-icon="icon-link"
                :placeholder="fields.slug.label"
                ref="focus"
                @input.native="debounceInput"
                v-model="model[fields.slug.name]"
              />
            </el-form-item>
          </el-col>
          <!-- Current Url  v-if="slugUrl.includes('null')"-->
          <el-col :lg="11" :md="11" :sm="24" class="subproperty-customize-form__row__col">
            <el-form-item :label="urlSlugLabel" class="subproperty-customize-form__row__col__slug-url">
              <a v-if="!slugUrl.includes('null')" :href="slugUrl" target="_blank">{{slugUrl}}</a>
              <a v-else>{{noUrlSlug}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Check Exist Slug -->
        <el-row :gutter="20" class="subproperty-customize-form__row">
          <!-- Loading Exists Slug -->
          <el-col :lg="11" :md="11" :sm="24" class="subproperty-customize-form__row__col">
            <!-- Loading -->
            <p
              v-if="checkExistsloading"
              class="subproperty-customize-form__check-exists-slug subproperty-customize-form__check-exists-slug--loading"
            >
              <app-i18n code="entities.subproperty.customize.checkExists.loading" />
              <loading-spinner />
            </p>
            <!-- Error -->
            <p
              v-else-if="isCheckErrorSlug"
              class="subproperty-customize-form__check-exists-slug subproperty-customize-form__check-exists-slug--error"
            >
              <i slot="prefix" class="icon-quit" />
              <app-i18n code="entities.subproperty.customize.checkExists.error" />
            </p>

            <!-- Success -->
            <p
              v-else-if="isCheckSuccessSlug"
              class="subproperty-customize-form__check-exists-slug subproperty-customize-form__check-exists-slug--success"
            >
              <i slot="prefix" class="icon-accept" />
              <app-i18n code="entities.subproperty.customize.checkExists.success" />
            </p>
          </el-col>

          <!-- New Url -->
          <el-col
            :lg="11"
            :md="11"
            :sm="24"
            v-if="isCheckSuccessSlug"
            class="subproperty-customize-form__row__col"
          >
            <el-form-item :label="newUrlSlugLabel" class="subproperty-customize-form__row__col__new-url">
              <span>{{ newUrlSlug }}</span>
            </el-form-item>
          </el-col>

          <el-col :lg="24" :md="24" :sm="24" class="subproperty-customize-form__row__col">
            <!-- Form controls -->
            <el-form-item class="subproperty-customize-form__row__col__buttons">
              <div class="form-buttons form-buttons--sides">
                <!-- Back button -->
                <el-button :disabled="updateLoading" @click="doBack" type="secondary">
                  <app-i18n code="common.backButton" />
                </el-button>

                <!-- Save button -->
                <el-button
                  :disabled="updateLoading || checkExistsloading || existsSlug || !isValidSlug"
                  @click="updateSlug"
                  type="primary"
                >
                  <app-i18n code="common.save" />
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { FormSchema } from '@shared/form/form-schema';
import { SubpropertyModel } from '@modules/subproperty/subproperty-model';
import LoadingSpinner from '@shared/components/loading-spinner.vue';
import { i18n } from '@shared/i18n';
import _ from 'lodash';
import config from '@/config';

const { fields } = SubpropertyModel;
const formSchema = new FormSchema([fields.slug]);

export default {
  name: 'app-subproperty-customize-page',

  props: {
    propertyId: {
      type: String,
      required: true,
    },
    subpropertyId: {
      type: String,
      required: true,
    },
  },

  data() {
    var validateSlug = (rule, value, callback) => {
      if (!this.isValidSlug) {
        callback(new Error(this.errorNoValidSlug));
      } else {
        callback();
      }
    };

    return {
      rules: {
        slug: {
          validator: validateSlug,
          trigger: 'blur',
        },
      },
      model: null,
    };
  },
  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      findLoading: 'subproperty/customize/findLoading',
      checkExistsloading: 'subproperty/customize/checkExistsloading',
      updateLoading: 'subproperty/customize/updateLoading',
      existsSlug: 'subproperty/customize/existsSlug',
      isCheckSuccessSlug: 'subproperty/customize/isCheckSuccessSlug',
      isRootScreen: 'layout/isRootScreen',
      slug: 'subproperty/customize/slug',
      slugUrl: 'subproperty/customize/slugUrl',
    }),
    fields() {
      return fields;
    },
    urlSlugLabel() {
      return i18n('entities.subproperty.customize.labels.currentUrl');
    },
    newUrlSlugLabel() {
      return i18n('entities.subproperty.customize.labels.newUrl');
    },
    newUrlSlug() {
      return this.getUrlSlug(this.model.slug);
    },
    isValidSlug() {
      const { slug } = this.model;
      if (!slug) return false;
      return /^[a-zA-Z0-9-]+$/.test(slug);
    },
    isCheckErrorSlug() {
      return this.existsSlug && this.isValidSlug;
    },
    errorNoValidSlug() {
      return i18n('entities.subproperty.customize.suportedCharacters');
    },
    noUrlSlug() {
      return i18n('entities.subproperty.customize.noUrlSlug');
    },
  },

  async created() {
    await this.doLoadSlug({
      subpropertyId: this.subpropertyId,
    });

    this.model = formSchema.initialValues({
      slug: this.slug,
    });
  },

  methods: {
    ...mapActions('subproperty/customize', [
      'doTyping',
      'doUpdateSlug',
      'doLoadSlug',
      'doCheckExistsSlug',
    ]),

    debounceInput: _.debounce(function() {
      const { slug } = this.model;

      this.doValidate();

      if (this.isValidSlug) {
        this.doCheckExistsSlug({ slug });
      }
    }, 500),

    updateSlug() {
      this.doUpdateSlug({
        propertyId: this.propertyId,
        subpropertyId: this.subpropertyId,
        slug: this.model[fields.slug.name]
      })
    },

    doValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          return true;
        } else {
          return false;
        }
      });
    },

    getUrlSlug(slug) {
      return `${config.registrationSiteUrl}/${slug}`;
    },

    doGoToSlugUrl(url) {
      window.open(url, '_blank');
    },

    doBack() {
      if (this.isRootScreen)
        this.$router.push({ name: 'home' });
      else this.$router.go(-1);
    },
  },

  watch: {
    'model.slug'() {
      this.doTyping();
    },
  },

  components: {
    LoadingSpinner,
  },
};
</script>

<style lang="scss">
  // Reset loading-spinner circular
  .subproperty-customize-form__check-exists-slug .loading-spinner .circular {
    height: initial;
    width: initial;
  }

  .subproperty-customize-form .el-form-item .el-form-item__label {
    color: #c5c5c5;
  }
</style>

<style lang="scss" scoped>
.subproperty-customize-form {
  &__row {
    &__col {
      &__slug {
      }
      &__slug-url {
        a {
          color: #2acccc;
          line-height: 1.71;
          letter-spacing: -0.3px;
          padding-left: 16px;
          font-weight: bold;
        }
      }
      &__new-url {
        span {
          padding-left: 16px;
          color: #404040;
        }
      }
      &__buttons {
        padding-top: 30px;
      }
    }
  }
  &__check-exists-slug {
    margin: 8px 8px 32px;
    font-size: 14px;
    height: 14px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 10px;

    .el-loading-spinner {
      margin-top: initial;
      top: initial;
      align-self: center;
      width: 14px;
      position: relative;
    }

    &--loading {
      align-self: left;
      color: #c5c5c5;
    }

    &--error {
      color: #ee7266;
    }

    &--success {
      color: #2acc73;
    }
  }
}
</style>

